const getClassNames = (existing, additional) => {
    const existingClasses = (existing && existing.split(' ')) || [];
    const addionalClasses = (additional && additional.split(' ')) || [];

    return [...existingClasses, ...addionalClasses].join(' ');
};

export default getClassNames;